// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"b781612d","125":"ebd16e53","247":"00a32272","422":"2552c1ed","457":"17e22729","551":"2e901c6e","627":"40c4aef8","640":"bc928e39","789":"3d390939","842":"c4792a2c","851":"5671cb01","867":"b420283c","923":"62a14974","938":"10874ee1"}[chunkId] + ".chunk.js";
};